import * as React from "react"
import {Box, IconButton} from "@mui/material";
import {PopoverSeeker} from "@ui-seeker/core"

import {appLang} from "../../../../@signals";
import MaximalLayoutHeaderchevronToolbar from "../chevronToolbar";
import {handleLangPopoverClose, openLangPopover} from "./signals";
import MaximalLayoutHeaderCountryOption from "./CountryOption";
import { dsColorNew } from "@palette"


export default function MaximalLayoutHeaderLangTool() {

	return <>
		<IconButton onClick={e => openLangPopover.value = e.currentTarget} sx={{ pb: 0 }}>
			<Box component="span" sx={{ fontSize: 18, color: dsColorNew.white }}>
				{appLang.value}
			</Box>
			<MaximalLayoutHeaderchevronToolbar isOpen={openLangPopover.value} />
		</IconButton>

		<PopoverSeeker anchorEl={openLangPopover.value} onClose={handleLangPopoverClose}>
			<MaximalLayoutHeaderCountryOption lang="EN" text="English" />
			<MaximalLayoutHeaderCountryOption lang="ES" text="Spanish" />
			<MaximalLayoutHeaderCountryOption lang="PT" text="Portuguese" />
		</PopoverSeeker>
	</>
}